import { Table, Button, Pagination, ButtonGroup } from "flowbite-react";
import { HiPlus, HiPencil, HiTrash } from "react-icons/hi";
import { useNavigate } from 'react-router-dom';
import { useEffect } from "react";
import { routes } from "../routes";
import { useReducerAsState } from "../hooks/useReducerAsState";
import useAds from "../hooks/useAds";
import { TableResults } from "../components";
import { toast } from "react-toastify";
import { useAuth } from "../context/authContext";

interface State {
    page: number;
    limit: number;
}

const AdsPage = () => {
    const { permissions } = useAuth()

    const canCreate = permissions.find(item => item.slug === 'crear-publicidad')
    const canEdit = permissions.find(item => item.slug === 'editar-publicidad')
    const canDelete = permissions.find(item => item.slug === 'borrar-publicidad')

    const { ads, loading, error, totalAds, fetchAds, deleteAd } = useAds()
    const [state, setState] = useReducerAsState<State>({
        page: 1,
        limit: 10
    })

    useEffect(() => {
        fetchAds({...state})
    },[state.page])

    const navigate = useNavigate();

    const onPageChange = (page: number) => setState({page})

    const handleCreate = () => navigate(`${routes.DASHBOARD}/${routes.ADS}/create`)

    const onDelete = async (itemId: number) => {
        if(!itemId || !canDelete) return

        const confirm = window.confirm('¿Deseas eliminar este usuario? Esta acción no se puede deshacer.')
        if(!confirm) return

        const deleted = await deleteAd(itemId)
        toast(deleted ? "Publicidad borrada correctamente" : "Error al borrar la publicidad.",{
            type: deleted ? "success" : "error"
        })

        await fetchAds({...state})
    }

    useEffect(() => {
        (async () => {
            await fetchAds({...state})
        })()
        // eslint-disable-next-line
    },[])

    return <div className="m-4">
        <div className="flex flex-col mb-4">
            <div className="mb-4">
                <h1>Publicidad</h1>
            </div>
            <div className="flex flex-row justify-between items-end">
                <div className="flex flex-row">
                    {canCreate && <Button onClick={handleCreate}>
                        <HiPlus className="mr-2 h-5 w-5" />
                        Crear publicidad
                    </Button>}
                </div>
            </div>
        </div>
        <TableResults
            loading={loading}
            error={error}
            itemsCount={totalAds}
        >
            <div className="overflow-x-auto mb-4 w-full bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                <Table>
                    <Table.Head>
                        <Table.HeadCell>Nombre</Table.HeadCell>
                        <Table.HeadCell></Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="divide-y">
                        {ads && ads.map((item) => <Table.Row key={item.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                            <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                                {item.title}
                            </Table.Cell>
                            <Table.Cell>
                            <ButtonGroup>
                                    {canEdit && <Button onClick={() => navigate(`${routes.DASHBOARD}/${routes.ADS}/${item.id}`)} color="gray">
                                        <HiPencil />
                                    </Button>}
                                    {canDelete && <Button onClick={() => onDelete(item.id!)} color="failure">
                                        <HiTrash />
                                    </Button>}
                            </ButtonGroup>
                            </Table.Cell>
                        </Table.Row>)}
                    </Table.Body>
                </Table>
            </div>
        </TableResults>
        {ads && <div className="flex overflow-x-auto sm:justify-center">
            <Pagination currentPage={state.page} totalPages={Math.ceil(totalAds / state.limit)} onPageChange={onPageChange} />
        </div>}
    </div>
}

export default AdsPage;